import React from 'react';
import I18n from 'i18n-js';
import CsrfForm from '../csrf_form';
import { GOOGLE_AUTH_PATH } from '../url_helpers';
import googleIcon from '@reverbdotcom/cadence/icons/vendor/google-color-logo.svg?component';
import { RCTextWithIcon, RCButton } from '@reverbdotcom/cadence/components';
import { MParticleEventName, trackEvent } from '../elog/mparticle_tracker';

interface Props {
  redirectTo?: string;
  isSignup?: boolean;
}

export default function GoogleSigninButton(props: Props) {
  const id = 'google-signup-signin';

  const title = props.isSignup
    ? I18n.t('commons.signupForm.googleSignUp')
    : I18n.t('commons.signupForm.googleSignIn');

  function trackGoogleSigninButtonClick() {
    trackEvent({
      eventName: MParticleEventName.ClickedGoogleSigninButton,
    });
  }

  return (
    <CsrfForm
      id={id}
      method="post"
      action={GOOGLE_AUTH_PATH.expand({ origin: props.redirectTo })}
    >
      <RCButton
        isSubmit
        fullWidth
        form={id}
        variant="secondary"
        onClick={trackGoogleSigninButtonClick}
      >
        <RCTextWithIcon
          svgComponent={googleIcon}
          placement="left"
          size="large"
        >
          {title}
        </RCTextWithIcon>
      </RCButton>
    </CsrfForm>
  );
}
